import styled from 'styled-components';

import { COLORS, STATUS_COLORS, MOBILE } from '../../../../theme/tokens';
import { Text } from '../../../../components';
import { hoverWash } from '@/nova/theme/mixins';

/** One session row: device chip · (name + meta) · trailing action/badge. */
export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 2px;
`;

/** Rounded tile holding the device glyph. */
export const IconChip = styled.div`
  flex: 0 0 auto;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: ${COLORS.surfaceFaint};
  border: 1px solid ${COLORS.hairline};
  color: ${COLORS.iconBright};
`;

/** Name + meta column. `min-width: 0` lets long names ellipsize instead of
 *  pushing the trailing action off-row. */
export const Info = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const Name = styled(Text)`
  font-size: 15px;
  font-weight: 600;
  color: ${COLORS.textStrong};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/** Secondary line: flag · country · last-seen time · browser. Wraps on narrow. */
export const Meta = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 13px;
  color: ${COLORS.textMuted};
`;

export const MetaText = styled(Text)`
  color: ${COLORS.textMuted};
`;

/** Decorative middot between meta parts. */
export const Sep = styled.span`
  color: ${COLORS.textFaint};
`;

/** Flag emoji — decorative (the country name carries the meaning). */
export const Flag = styled.span`
  font-size: 14px;
  line-height: 1;
`;

/** Trailing area (fixed against the row's right edge). */
export const Trailing = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
`;

/** Compact "Log out" pill for a non-current session. Hover → danger. */
export const RowAction = styled.button`
  appearance: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: ${COLORS.textSubtle};
  background: transparent;
  border: 1px solid ${COLORS.hairline};
  border-radius: 99px;
  padding: 7px 14px;
  transition:
    color 0.15s ease,
    border-color 0.15s ease,
    background 0.15s ease;

  /* Cursor-following hover glow + lit hairline ring (shared with the CTA Button). */
  ${hoverWash}

  &:hover:not(:disabled) {
    color: ${STATUS_COLORS.negative};
    border-color: ${STATUS_COLORS.negative};
  }

  &:disabled {
    cursor: default;
    opacity: 0.55;
  }

  &:disabled:hover::before,
  &:disabled:hover::after,
  &:disabled:focus-visible::before,
  &:disabled:focus-visible::after {
    opacity: 0;
  }

  ${MOBILE} {
    padding: 7px 12px;
  }
`;
